var render, staticRenderFns
import script from "./PolarAreaChart.vue?vue&type=script&lang=js&"
export * from "./PolarAreaChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977624ac",
  null
  
)

export default component.exports